<template>
    <el-dialog :visible.sync="boxVisible2" class="myDialog RegisterBox"
        :modal="true" :close-on-click-modal="false" :close-on-press-escape="false" :align-center="true" :show-close="false">
        <div class="myDialog-body">
            <i class="el-icon-circle-close myDialog-close" @click="close"></i>
            <div class="register-title">{{ $t("bind.title") }}</div>
            <div class="register-code">
                <div class="codeInput">
                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 2}" :placeholder="$t('bind.holder')" v-model="inputParentAddress" resize="none"> </el-input>
                </div>
            </div>
            <div class="register-bottom">
                <div class="register-button" @click="confirmBindParent">{{ $t('bind.confirm') }}</div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import bus from '@/assets/js/bus';
import { getUserName} from '@/assets/js/user';
import Web3 from 'web3';
export default {
    props:{
        boxVisible: Boolean,
    },
    data() {
        return {
            boxVisible2:this.boxVisible,
            inputParentAddress:"",

            walletAddress:"",
            web3Instance:null,
            mpcTeamContractInstance:null,
        };
    },
    created() {
        this.inputParentAddress = "";
        this.web3Instance = new Web3(window.ethereum);
        this.mpcTeamContractInstance = new this.web3Instance.eth.Contract(this.MpcTeam_Contract.abi, this.MpcTeam_Contract.address);
    },
    methods:{
        show() {
            let code = this.getUrlCode();
            if(code != ""){
                this.inputParentAddress = code;
            }else{
                this.inputParentAddress = "";
            }
            this.boxVisible2 = true;
            this.walletAddress = getUserName();
        },
        close() {
            this.inputParentAddress = "";
            this.boxVisible2 = false;
        },
        async confirmBindParent(){
            let _this = this;
            let parent = this.inputParentAddress.trim().toLocaleLowerCase();
            if(parent == "" || !this.web3Instance.utils.isAddress(parent) || parent == this.zeroAddress){
                this.$message.warning({message: this.$t('bind.errorCode'),duration: 1500})
                return;
            }
            if(parent == this.walletAddress.toLocaleLowerCase()){
                this.$message.warning({message: this.$t('bind.cannotBeSelf'),duration: 1500})
                return;
            }
            let checkResult = await this.mpcTeamContractInstance.methods.checkParent(this.walletAddress,parent).call();
            if(!checkResult){
                this.$message.warning({message: this.$t('bind.cannotBeChild'),duration: 1500})
                return;
            }
            let method = this.mpcTeamContractInstance.methods.bindParent(parent);
            let bnbAmount = null;
            // let gasprice = await this.web3Instance.eth.getGasPrice();
            // console.log("gasPrice:",gasprice);
            // method.estimateGas({from: this.walletAddress, value:bnbAmount}).then(function(result){
            //     console.log("estimateGas:",result);
            // }).catch((err) => {
            //     console.log("estimateGas:",err)
            // });
            this.showConfirmBox();
            this.contractSend (method,this.walletAddress,bnbAmount).then(function(result){
                _this.hideConfirmBox();
                if(result.status){
                    _this.$message.success({message: _this.$t('bind.bindSuccess'),duration: 1500})
                    bus.$emit("refreshWalletData");
                }else{
                    _this.$message.error({message: _this.$t('bind.bindFail'),duration: 1500})
                }
                _this.close();
            }).catch((error) => {
                _this.hideConfirmBox();
                _this.$message.error({message: _this.$t('bind.bindFail'),duration: 1500})
            });
        }
    }
}
</script>

<style lang="less">
.RegisterBox{
    display: flex;
    div.el-dialog{
        // background: none !important;
        width: 100%;
        -webkit-box-shadow:none;
        margin: auto 10px !important;
        .el-dialog__header{
            display: none;
        }
        .el-dialog__body{
            padding: 0px !important;
        }
    }
    .myDialog-body {
        padding: 20px 20px !important;
        display: flex;
        flex-direction: column;
        .register-title {
            color: #ffffff;
            font-weight: bolder;
            font-size: 18px;
            margin:0px 0px 20px 0px;
        }
        .register-code{
            .codeInput{
                padding: 0px 10px;
                height: 60px;
                border-radius: 5px;
                background: rgba(255,255,255,0.13);
                display: flex;
                align-items: center;
                .el-textarea{
                    background: transparent;
                    border: none;
                    padding: 0px;
                    color: #ffffff;
                    font-size: 15px;
                }
                .el-textarea__inner{
                    background: transparent;
                    border: none;
                    padding: 0px;
                    color: #ffffff;
                    font-size: 15px;
                }
                textarea::-webkit-input-placeholder{
                    font-size:15px;
                    color: #A2BED9;
                    font-weight:normal;
                }
                .el-input{
                    height:100%;
                }
                input{
                    border:none;
                    font-size:15px;
                    color: #FFFFFF;
                    height: 100%;
                    border:2px solid rgba(255, 255, 255, 0);
                    border:none;
                    background: transparent !important;
                    padding: 0px!important;
                }
                input:focus{
                    outline: none;
                    border:2px solid #ffffff;
                    border:none;
                    color: #FFFFFF;
                }
                input::-webkit-input-placeholder{
                    font-size:15px;
                    color: #A2BED9;
                    font-weight:normal;
                }
            }
        }
        .register-bottom{
            .register-button {
                margin-top: 25px;
                font-size: 14px;
                height: 45px;
                line-height: 45px;
                color:#000000;
                text-align: center;
                cursor: pointer;
                background:url('~@/assets/images/mpc/bg-btn.png') 0px 0px no-repeat;
                background-size: 100% 100%;
            }
        }
        
    }
}
</style>
